"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var webpack_merge_1 = require("webpack-merge");
var runner_1 = __importDefault(require("../runner"));
var tauri_config_1 = __importDefault(require("../helpers/tauri-config"));
var logger_1 = __importDefault(require("../helpers/logger"));
var chalk_1 = __importDefault(require("chalk"));
var os_1 = require("os");
var path_1 = require("path");
var cross_spawn_1 = require("cross-spawn");
var error = logger_1.default('tauri:dev', chalk_1.default.red);
module.exports = function (config) {
    if (os_1.platform() === 'win32') {
        var child = cross_spawn_1.sync('powershell', [
            path_1.resolve(__dirname, '../../scripts/is-admin.ps1')
        ]);
        var response = String(child.output[1]).replace('\n', '').trim();
        if (response === 'True') {
            error("Administrator privileges detected. Tauri doesn't work when running as admin, see https://github.com/Boscop/web-view/issues/96");
            process.exit(1);
        }
    }
    var tauri = new runner_1.default();
    var tauriConfig = tauri_config_1.default(webpack_merge_1.merge({
        ctx: {
            debug: true,
            dev: true
        }
    }, config));
    return {
        runner: tauri,
        promise: tauri.run(tauriConfig)
    };
};
